import { AxiosStatic } from 'axios';

export default class CallService {
    axios;

    constructor(axios: AxiosStatic) {
        this.axios = axios;
    }

    async createUserCall(receiverId) {
        const res = this.axios.post('/call/user', { receiverId });

        return res;
    }

    async createUserCallByPhone(phoneNumber) {
        const res = this.axios.post('/call/user', { phoneNumber });

        return res;
    }

    async createGroupCall(groupId: string) {
        const res = this.axios.post(`/call/group/${groupId}`);

        return res;
    }

    async addUserIntoCall(roomId, userId) {
        this.axios.post(`/call/add/user/${roomId}/${userId}`);
    }

    async joinCall(id: string) {
        this.axios.post(`/call/${id}/join`);
    }

    async rejectCall(id: string) {
        this.axios.post(`/call/${id}/reject`);
    }

    async endCall(id: string) {
        this.axios.post(`/call/${id}/end`);
    }
}
